var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Search_Icon",
    "data-name": "Search Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.706,
    height: 16.706,
    viewBox: "0 0 16.706 16.706",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_884",
    "data-name": "Group 884"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    fill: "#fff",
    stroke: "#ffa539",
    strokeLinecap: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.72,
    cy: 6.862,
    rx: 6.72,
    ry: 6.862,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.72,
    cy: 6.862,
    rx: 6.22,
    ry: 6.362,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M0,0,3.223,3.51",
    transform: "translate(12.777 12.49)",
    fill: "none",
    stroke: "#14a4c2",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/Search Icon.c21abd0865b39d445cb9bb21a36051d2.svg";
export { ForwardRef as ReactComponent };